// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import Branding from '../../../components/Header/Branding';

import { getThemes } from '../../../reducers/portalConfig';
import { getAlternateLogo } from "../../../utils";

import { useLogin } from "../context";
import { getThemeDetails } from "../utils";

const BrandLogo = ({ classes, hideProviderInfo }) => {
  const { selectedAuthSchemeType, selectedAuthScheme } = useLogin();

  const themeData = useSelector(getThemes);
  const { logo: portalLogo, siteTitle } = getThemeDetails(themeData);

  let logo = portalLogo;
  let providerName = siteTitle;
  let description = '';
  let alternateLogo = getAlternateLogo(siteTitle);

  if (selectedAuthSchemeType === 'external') {
    logo = selectedAuthScheme.logo ? selectedAuthScheme.logo : portalLogo;
    providerName = selectedAuthScheme.name;
    description = selectedAuthScheme.description;
    alternateLogo = getAlternateLogo(selectedAuthScheme.name)
  }

  const renderAlternateLogo = selectedAuthScheme && <Typography variant='h1' className={classes.alternateLogo} align='center'>
    {alternateLogo}
  </Typography>

  return (
    <Box className={classes.header}>
      {logo ? <Branding logo={logo} /> : (renderAlternateLogo)}
      {!hideProviderInfo && <Typography
        data-apim-test='login-header'
        id='provider-name'
        variant='h1' className={classes.headerText}
      >
        {providerName}
      </Typography>}
      {!hideProviderInfo && description && <Typography
        data-apim-test='login-description'
        id='idp-desc'
        variant='h4' className={classes.descriptionText}
      >
        {description}
      </Typography>}
    </Box>
  )
}

BrandLogo.propTypes = {
  classes: PropTypes.shape(),
  hideProviderInfo: PropTypes.bool,
}

export default BrandLogo;
